import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { Route, Switch, withRouter } from 'react-router-dom'
import PaymentContainer from '../PaymentContainer'
import Contributions from '../../Views/Contributions'
import React from 'react'
import { useMutation } from 'react-apollo'
import { CREATE_PAYMENT_INTENT } from '../../queries/paymentIntent'
import { PanelContentContainer } from '../shared.styles'
import { LoadingComponent } from '@pga/pga-component-library'

const StripeContainer = () => {
  const [createPaymentIntent] = useMutation(CREATE_PAYMENT_INTENT)

  const [clientSecret, setClientSecret] = React.useState(null)
  const [paymentIntentId, setPaymentIntentId] = React.useState(null)
  const paymentIntentRef = React.useRef(null)

  const setPaymentIntent = id => {
    paymentIntentRef.current = id
    setPaymentIntentId(id)
  }

  const initializePayment = React.useCallback(async () => {
    if (!clientSecret) {
      const { data } = await createPaymentIntent({
        variables: {
          input: {
            amount: 1,
            email: 'temp@pga.org',
            origin: window.location.origin
          }
        }
      })
      const { clientSecret, id } = data.createPaymentIntent
      setPaymentIntent(id)
      setClientSecret(clientSecret)
    }
  }, [clientSecret, createPaymentIntent])

  React.useEffect(() => {
    initializePayment()
    // eslint-disable-next-line
  }, [])

  if (!clientSecret) {
    return <LoadingComponent />
  }

  return (
    <PanelContentContainer>
      <Switch>
        {clientSecret &&
          <Elements options={{ clientSecret }} stripe={loadStripe(process.env.REACT_APP_STRIPE_PK)}>
            <Route exact path='/' render={(props) => <PaymentContainer clientSecret={clientSecret} paymentIntentId={paymentIntentId} {...props} />} />
            <Route exact path='/contributions' render={(props) => <Contributions paymentIntentId={paymentIntentId} {...props} />} />
          </Elements>}
      </Switch>
    </PanelContentContainer>
  )
}

export default withRouter(StripeContainer)
